import { createContext, type FC, type ReactElement, useState } from 'react';
import type { LogEvent, LogGroup, LogStream } from '../models/api-calls/logs.api';

interface ILogsContext {
  logGroups: LogGroup[];
  setLogGroups: (val: LogGroup[]) => void;
  loadingGroups: boolean;
  setLoadingGroups: (val: boolean) => void;
  expandedGroupName: string | null;
  setExpandedGroupName: (val: string | null) => void;
  streamsByGroup: Record<string, LogStream[]>;
  setStreamsByGroup: (val: Record<string, LogStream[]>) => void;
  loadingStreamsByGroup: Record<string, boolean>;
  setLoadingStreamsByGroup: (val: Record<string, boolean>) => void;
  expandedStreamName: string | null;
  setExpandedStreamName: (val: string | null) => void;
  eventsByStream: Record<string, LogEvent[]>;
  setEventsByStream: (val: Record<string, LogEvent[]>) => void;
  nextTokenByStream: Record<string, string | undefined>;
  setNextTokenByStream: (val: Record<string, string | undefined>) => void;
  loadingEventsByStream: Record<string, boolean>;
  setLoadingEventsByStream: (val: Record<string, boolean>) => void;
  levelFilter: string[];
  setLevelFilter: (val: string[]) => void;
}

export const LogsContext = createContext<ILogsContext>({} as ILogsContext);

export const LogsProvider: FC<{ children: ReactElement }> = ({ children }) => {
  const [logGroups, setLogGroups] = useState<LogGroup[]>([]);
  const [loadingGroups, setLoadingGroups] = useState(false);
  const [expandedGroupName, setExpandedGroupName] = useState<string | null>(null);
  const [streamsByGroup, setStreamsByGroup] = useState<Record<string, LogStream[]>>({});
  const [loadingStreamsByGroup, setLoadingStreamsByGroup] = useState<Record<string, boolean>>({});
  const [expandedStreamName, setExpandedStreamName] = useState<string | null>(null);
  const [eventsByStream, setEventsByStream] = useState<Record<string, LogEvent[]>>({});
  const [nextTokenByStream, setNextTokenByStream] = useState<Record<string, string | undefined>>({});
  const [loadingEventsByStream, setLoadingEventsByStream] = useState<Record<string, boolean>>({});
  const [levelFilter, setLevelFilter] = useState<string[]>(['INFO', 'WARN', 'ERROR', 'DEBUG']);

  return (
    <LogsContext.Provider
      value={{
        logGroups,
        setLogGroups,
        loadingGroups,
        setLoadingGroups,
        expandedGroupName,
        setExpandedGroupName,
        streamsByGroup,
        setStreamsByGroup,
        loadingStreamsByGroup,
        setLoadingStreamsByGroup,
        expandedStreamName,
        setExpandedStreamName,
        eventsByStream,
        setEventsByStream,
        nextTokenByStream,
        setNextTokenByStream,
        loadingEventsByStream,
        setLoadingEventsByStream,
        levelFilter,
        setLevelFilter
      }}
    >
      {children}
    </LogsContext.Provider>
  );
};
